/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

/** @description import Global or some other files only if you need them */
import Global from '../shared/global';

'use strict';
const changeBG = {
	/**
	 * @description Cache dom and strings
	 * @description Please always define selectors, classes and data attributes with the following prefixes
	 * @type {object}
	 * @param {jQuery} $dom     for any jQuery selectors    - example: $domMenu: $('.js-menu')
	 * @param {string} sl       for any string selectors    - example: slMenu: '.js-menu'
	 * @param {string} class    for any class strings       - example: classActive: 'is-active'
	 * @param {string} attr     for any attributes strings  - example: attrIndex: 'data-index'
	 */

	$domThankYouPage: $('.js-thank-you-screen'),
	$domBody: $('body'),

	/**
	 * @description Initialize
	 * @example this.someFunction();
	 */
	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		if (this.$domThankYouPage.length > 0) {
			this.$domBody.addClass('image-left');
		}
	}
};

export default changeBG;
